export enum CheckpointType {
    Status,
    Measurement,
}

export enum CheckpointRangeType {
    Between,
    Greater,
    Less,
}

export enum CheckpointConditionType {
    IsOk = 3,
    IsNotOk = 4,
    Always = 5,
}

export enum CheckpointConditionTargetType {
    Comment = 0,
    Attachment = 1,
    QRCode = 2,
}

/*export enum ChecklistStatus {
    Failed = 4,
    Deviation = 3,
    Ok = 2,
    NotFilledOut = 1,
    OkCheckpoints = 'ok', // using only on frontend,
    DeviationCheckpoints = 'deviation'  // using only on frontend,
}*/

export enum CheckpointActionType {
    CreateTask = 0,
    SendNotification = 1,
}

export enum CheckpointActionRecipientType {
    Roles = 0,
    Users = 1,
    EmailAddress = 2,
    SMS = 3,
    RolesLocal = 4,
}

export enum CheckpointActionLocationType {
    OnlyCurrent = 0,
    AnyUserBelongsTo = 1,
}

export enum CheckpointActionTimePeriodType {
    Days = 0,
    Weeks = 1,
    Months = 2,
}

export enum CheckpointEditorTabs {
    General,
    Conditions,
    Actions,
}

export enum Checkpoint2StatusType {
    NotOk = 0, // deviation
    Ok = 1,
    NotFilledOut = 2,
    //Answered = 3,
    //AddedValueRange = 4,
}

/*export enum Checklist2StatusType { // todo use Checkpoint2StatusType?
    Deviation = 0,
    Ok = 1,
    NotFilledOut = 2,
}*/

export enum CheckpointActionConditionType {
    NotOk = 0,
    Ok = 1,
    NotFilledOut = 2,
    Answered = 3,
    ComplianceThreshold = 4,
}

export enum CheckpointAnswerLogType {
    ReportingAsOk = 0,
    ReportingAsNotOk = 1,
    ChangingReportedValue = 2,
    Commenting = 3,
    UpdatingComment = 4,
    RemovingComment = 5,
    AddingAttachment = 6,
    RemovingAttachment = 7,
    ClearedCheckpoint = 8,
    RemovingInvalidAttachment = 9,
}

export enum ChecklistCreationTypes {
    Template,
    Manual,
    UploadFromExcel,
}

export enum Checkpoint2MeasureUnitType {
    Others = 0,
    Fahrenheit = 1,
    Celsius = 2,
    Kilogram = 3,
    Ph = 4,
    Pounds = 5,
    Hours = 6,
    Minutes = 7,
    Pieces = 8,
    Percent = 9,
}

export enum CheckpointScoringType {
    Minor = 0,
    Major = 1,
    Critical = 2,
}

export enum CheckpointEditorFormModelNames {
    Name = 'CheckpointNameModel',
    Type = 'CheckpointTypeModel',
    MeasureUnit = 'CheckpointMeasureUnitModel',
    Ranges = 'CheckpointRangesModel',
    Scoring = 'CheckpointScoringModel',
    ConditionType = 'CheckpointConditionTypeModel',
    ConditionTargetType = 'CheckpointConditionTargetTypeModel',
}
